export default "__VITE_ASSET__ogp5nX7m__"